import React, { useContext } from 'react';
import View from '../component/View';
import apiService from '../../../../../apiService';
import { AdminContext } from '../../index';

const VerifikasiRumahMakan = ({ data }) => {
  const { setContextData } = useContext(AdminContext);
  const handleSubmit = async (
    { id, status, keterangan },
    callBack = () => {}
  ) => {
    const params = {
      ref_persyaratan_id: id,
      trx_pend_perusahaan_id: data.id,
      verified: status,
      keterangan: keterangan,
    };
    const result = await apiService.put(
      'department/persyaratan/verify',
      params
    );
    if (result.code === 200) callBack(status);
  };

  const setTanggalKunjungan = async (
    { date, name = '', reason = '' },
    callBack
  ) => {
    const params = {
      registration_id: data.id,
      editor_id: JSON.parse(localStorage.getItem('userData')).id,
      nama: name,
      alasan: reason,
      visit_date: date,
    };
    const result = await apiService.post('department/visit_date', params);
    if (result.code === 200) {
      setContextData({ tanggalKunjungan: date });
      callBack();
    }
  };

  return (
    <View
      data={ data.persyaratan_result ? data.persyaratan_result : [] }
      handleSubmit={ handleSubmit }
      setTanggalKunjungan={ setTanggalKunjungan }
      visitDateHistory={ data.visit_date_history }
    />
  );
};

export default VerifikasiRumahMakan;
